import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { DOMSerializer } from '@atlaskit/editor-prosemirror/model';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
var injectNodeViewNodeTypeList = ['paragraph', 'heading', 'bulletList', 'orderedList', 'blockquote', 'rule', 'decisionList', 'taskList', 'layoutColumn', 'hardBreak'];
var key = new PluginKey('editorNativeAnchorSupportPlugin');

// Internal plugin to enable native anchor support in the editor.
// This plugin injects node views for specific node types (e.g., 'paragraph', 'heading')
// that do not already have a nodeView, allowing them to be rendered with native anchors when needed.
export var createEditorNativeAnchorSupportPlugin = function createEditorNativeAnchorSupportPlugin(schema) {
  var nodeViewEntries = [];
  schema.spec.nodes.forEach(function (nodeName, nodeSpec) {
    if (injectNodeViewNodeTypeList.includes(nodeName)) {
      if (nodeSpec.toDOM && typeof nodeSpec.toDOM === 'function') {
        var toDOM = nodeSpec.toDOM.bind(nodeSpec);
        nodeViewEntries.push([nodeName, function (node) {
          return DOMSerializer.renderSpec(document, toDOM(node));
        }]);
      }
    }
  });
  return new SafePlugin({
    key: key,
    props: {
      nodeViews: Object.fromEntries(nodeViewEntries)
    }
  });
};